<template>
    <m-input :active="focus" @click="setFocus()" :helper="helperText" :error="error">
        <input class="w-full outline-none p-2 bg-transparent border-gray-400 rounded-md shadow-md" :placeholder="placeholder"
               v-bind="getAttrs()" v-model.number="text" :readonly="readonly" @focus="updateFocus(true)"
               @blur="updateFocus(false)" ref="input" @keydown.enter="$emit('enter')"
               :class="this.bottom ? 'border-b' : 'border'"/>
        <slot></slot>
    </m-input>
</template>
<script>
// Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter, update) {
    [
        "input",
        "keydown",
        "keyup",
        "mousedown",
        "mouseup",
        "select",
        "contextmenu",
        "drop"
    ].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (!this.value || this.value.length == 0) {
                return
            }
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
                update(this.value)
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                update(this.value)
                this.setSelectionRange(
                    this.oldSelectionStart,
                    this.oldSelectionEnd
                );
            } else {
                update(null)
                this.value = ''
            }
        });
    });
}

export default {
    props: {
        name: String,
        value: String,
        error: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            defaulat: false
        },
        placeholder: String
    },
    watch: {
        // detect external change
        value(newval, oldval) {
            this.text = newval
        }
    },
    data() {
        return {
            focus: false,
            text: this.value,
            update: false
        };
    },
    methods: {
        getAttrs() {
            var obj = {}
            if (this.name) {
                obj.name = this.name
            }
            // Only way now to disable autocompletion
            if (!this.autocomplete) {
                obj.autocomplete = 'new-password'
            }
            return obj
        },
        updateFocus(state) {
            this.focus = state
            this.$emit('focus', state)
        },

        setFocus() {
            this.$refs.input.focus();
        }
    },
    mounted() {
        setInputFilter(this.$refs.input, val => /^\d+[\.,]?\d*$/.test(val), val => {
            // javascript only use . as decimal seperator
            var format = (val || '').replace(',', '.')
            this.update = true
            this.$emit('input', parseFloat(format))
        })
    }
};
</script>
